var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-block-title"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"en"},[_vm._v(_vm._s(_vm.en))]),_c('div',{staticClass:"block"})])
}
var staticRenderFns = []

export { render, staticRenderFns }